exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#inbox{width:30%;overflow:auto;box-sizing:border-box;background-color:var(--inbox-panel-color);padding-left:var(--horizontal-panel-padding);padding-right:var(--horizontal-panel-padding)}#inbox input:focus{background-color:hsla(0,0%,100%,.7)}#inbox ul{padding-left:0}#inbox .inbox-filter{margin-bottom:2em}.inbox-item{display:flex;list-style-type:none;margin-top:var(--infobit-list-spacing)}.inbox-item .infobit{padding-top:var(--infobit-padding-top);padding-bottom:var(--infobit-padding-bottom)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-074a4f01!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/inbox.vue
// module id = 76
// module chunks = 0